import { classNames } from '@shopify/css-utilities'
import { Link } from '@shopify/hydrogen'
import { Children, Dispatch, SetStateAction, useEffect, useState } from 'react'
import styles from '../../assets/scss/components/campaigns/campaign-details.module.scss'
import { AcfImage as AcfImageType } from '../../lib/acf'
import { AcfImage } from '../acf-image.client'
import { useI18n } from '../i18n.client'

export const CampaignDetails: React.FC<{
  largeImages: AcfImageType[][] | undefined
  smallImages: AcfImageType[][] | undefined
}> = ({ largeImages, smallImages }) => {
  const [activeIndex, setActiveIndex] = useState<number>()
  const [i18n] = useI18n()

  if (!largeImages || !smallImages) {
    return null
  }

  if (activeIndex !== undefined) {
    return <LargeImage largeImage={largeImages[activeIndex]} setActiveIndex={setActiveIndex} />
  }

  return (
    <section className={classNames('section', styles.grid)}>
      <div className={styles.backContainer}>
        <div className="section px">
          <Link className={styles.back} to="/campaigns">
            {i18n.translate('back')}
          </Link>
        </div>
      </div>
      {Children.toArray(
        smallImages.map((image, index) => (
          <div className={styles.imageContainer}>
            <AcfImage acf={image} className={styles.image} onClick={() => setActiveIndex(index)} />
          </div>
        )),
      )}
    </section>
  )
}

const LargeImage: React.FC<{
  largeImage: AcfImageType[] | false
  setActiveIndex: Dispatch<SetStateAction<number | undefined>>
}> = ({ largeImage, setActiveIndex }) => {
  const [i18n] = useI18n()
  const [mouseX, setMouseX] = useState(0)
  const [mouseY, setMouseY] = useState(0)

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      setMouseX(event.clientX + 10)
      setMouseY(event.clientY + 20)
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.scrollTo(0, 0)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  if (!largeImage) {
    return null
  }

  return (
    <section className="section">
      <div className={styles.cursor} style={{ left: `${mouseX}px`, top: `${mouseY}px` }}>
        {i18n.translate('close')}
      </div>
      <AcfImage acf={largeImage} className="fit-width" onClick={() => setActiveIndex(undefined)} />
    </section>
  )
}
